/* @jsx h */
import { defineComponent, h } from "vue";

export interface AddressDisplayProps {
  street?: string;
  city?: string;
  postalCode?: string;
  companyName?: string;
  phone?: string;
  email?: string;
  variant?: "compact" | "detailed";
}

export const AddressDisplay = defineComponent<AddressDisplayProps>({
  name: "AddressDisplay",
  props: [
    "street",
    "city",
    "postalCode",
    "companyName",
    "phone",
    "email",
    "variant",
  ],
  setup(props) {
    const isCompact = props.variant === "compact";

    return () => (
      <div class={`space-y-${isCompact ? "1" : "2"}`}>
        {props.companyName && (
          <div class={isCompact ? "text-sm" : ""}>
            <span class="text-xs font-medium text-base-content/50 uppercase tracking-wide">
              Company
            </span>
            <p class="font-medium text-base-content/90">{props.companyName}</p>
          </div>
        )}

        {props.street && (
          <div class={isCompact ? "text-sm" : ""}>
            <span class="text-xs font-medium text-base-content/50 uppercase tracking-wide">
              Street
            </span>
            <p class="text-base-content/80">{props.street}</p>
          </div>
        )}

        <div
          class={`grid grid-cols-2 gap-${isCompact ? "2" : "3"} ${
            isCompact ? "text-sm" : ""
          }`}
        >
          {props.postalCode && (
            <div>
              <span class="text-xs font-medium text-base-content/50 uppercase tracking-wide">
                Zip
              </span>
              <p class="text-base-content/80">{props.postalCode}</p>
            </div>
          )}

          {props.city && (
            <div>
              <span class="text-xs font-medium text-base-content/50 uppercase tracking-wide">
                City
              </span>
              <p class="text-base-content/80">{props.city}</p>
            </div>
          )}
        </div>

        {(props.phone || props.email) && (
          <div class={`space-y-1 pt-${isCompact ? "1" : "2"} `}>
            {props.phone && (
              <div class="flex items-center gap-2 text-xs">
                <span class="material-symbols-outlined text-sm text-base-content/50">
                  phone
                </span>
                <span class="text-base-content/70">{props.phone}</span>
              </div>
            )}
            {props.email && (
              <div class="flex items-center gap-2 text-xs">
                <span class="material-symbols-outlined text-sm text-base-content/50">
                  mail
                </span>
                <span class="text-base-content/70">{props.email}</span>
              </div>
            )}
          </div>
        )}
      </div>
    );
  },
});
